/* eslint-disable consistent-return */
import React, { useState, useEffect, useRef, Fragment } from 'react';
import Loader from '../../Common/Loader';
// import ReactFileReader from 'react-file-reader';
// import { ExportToCsv } from 'export-to-csv';
import axios from 'axios';
import constants from '../../../constants';
import { cookieStorageUtility } from '../../../utils/utilityFunctions';
import { checkRole } from '../../Common/CheckRole';

const { serverUrl, ENCRYPTOR_KEY, REDIRECT_URL } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const DecreaseInventoryWrapper = () => {
  const [list, setList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const csvRef = useRef();
  const [csv] = useState([]);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('error');
  const [message, setMessage] = useState('');
  const [total, setTotal] = useState('');
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    uploadedCSVlist();
    // eslint-disable-next-line
  }, [pageNumber]);

  const setMessageHandler = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  const uploadedCSVlist = () => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploadedcsvlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        page: pageNumber,
        limit: limit,
        request_from: 'decrease_inventory'
      }
    })
      .then(response => {
        if (response.data.status === 'success') {
          setList(response.data.data);
          setTotal(response.data.total);
        } else {
          setMessageHandler('error', response.data.message);
        }
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const handleFiles = files => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    let formData = new FormData();
    formData.append('file', files[0]);
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploaddecreaseinventory', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        token: btoa(authUserId + '|' + encryptedToken),
        guestHouseId: btoa(hotelId)
      },
      data: formData
    })
      .then(response => {
        if (response.data.status === 'success') {
          setMessageHandler('success', response.data.message);
        } else {
          setMessageHandler('error', response.data.message);
        }
        uploadedCSVlist();
        setShowUILoader(false);
      })
      .catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
  };

  const download = (csvId) => {
    const hotelId = cookieStorageUtility.fetch('hotelId');
    setShowUILoader(true);
    axios(serverUrl + 'channel/uploadedcsvlist', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: {
        hotelId,
        page: pageNumber,
        limit: limit,
        request_from: 'decrease_inventory',
        csvId
      }
    }).then(response => {
      if (response.data.status === 'success') {
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          showTitle: false,
          filename: 'decrease_inventory_error',
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: true
        };
        // const csvExporter = new ExportToCsv(options);
        // csvExporter.generateCsv(response.data.data);
      } else {
        setMessageHandler('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  };

  const renderCSVlist = () => {
    if (Object.keys(list).length > 0) {
      return Object.keys(list).map(id => {
        var data = list[id];
        var autoNumber = parseInt(id) + 1 + (pageNumber - 1) * limit;
        return (
          <div className="table_row border_t_1 border_color_1" key={id}>
            <div className="tabcel align_middle pad10">{autoNumber}</div>
            <div className="tabcel align_middle pad10">{data.file_name}</div>
            <div className="tabcel align_middle pad10">{data.first_name} {data.last_name}</div>
            <div className="tabcel align_middle pad10">{data.status}</div>
            <div className="tabcel align_middle pad10">
              {data.is_error === 1
                ? <span className='cursor_p' onClick={() => download(data.id)}>
                  Download Error Report{' '}
                </span>
                : <span className='cursor_p'>N/A </span>}
            </div>
            <div className="tabcel align_middle pad10">{data.created_on}</div>
          </div>
        );
      });
    }
  };

  const handlePageChange = pageNumber => {
    setPageNumber(pageNumber);
  };

  return (
    <Fragment>
      {showUILoader ? <Loader /> : ''}
      <div className="container_fluid topheading pad_lft_rht25 pad_top_bot10 text-start">
        <div className="row">
          <div className="col-xs">
            <div className="d-full-height justify-content-center fnt18 tu">Upload Decrease Inventory</div>
          </div>
          {checkRole('upload_decrease_inventory') && <Fragment>
            <div className="col-xs-auto">
              {/* <ReactFileReader handleFiles={handleFiles} fileTypes={'.csv'}>
                <button className="pad12 btn1 cursor_p">Upload CSV File</button>
              </ReactFileReader> */}
            </div>
            <div className="col-xs-auto">
              <button
                onClick={() => window.open(REDIRECT_URL + '/assets/decrease_inventory_sample_file.csv', '_blank')}
                className="pad12 btn1 cursor_p">
                Sample File Download
              </button>
            </div>
          </Fragment>}
        </div>
      </div>
      {flag ? (
        <div
          className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
        >
          {message}
        </div>
      ) : ''}
      <div className="container_fluid pad_lft_rht20 padtop25 text-start">
        <div className="cover border_all_1 border_color_1">
          <div className="scrolly_auto">
            <div className="table_col table_fixed">
              <div className="table_row bg2_8">
                <div className="tabcel align_middle pad10 tu bld wdhpx50">S.No.</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">File Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">User Name</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">Status</div>
                <div className="tabcel align_middle pad10 tu bld wdhpx150">
                  Download Error Report <span className="fa fa-file-excel-o"></span>
                </div>
                <div className="tabcel align_middle pad10 tu bld wdhpx100">Date</div>
              </div>
              {renderCSVlist()}
            </div>
          </div>
          {total === 0 && !showUILoader ? (
            <div className="cover pad30 border_t_1 border_color_1">
              <div className="ovr tc marg_bottom10">
                <div className="inline">
                  <img src="/images/no_result.png" alt="No Markup Found" />
                </div>
              </div>
              <div className="ovr tc fnt16 bld">No result Found</div>
            </div>
          ) : ''}
        </div>
        {total > limit ? (
          <div className="cover tc margtop15">
            {/* <Pagination
              activePage={pageNumber}
              itemsCountPerPage={limit}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
            /> */}
          </div>
        ) : ''}
      </div>
    </Fragment>
  );
};

export default DecreaseInventoryWrapper;
